export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('row');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;
    const TYPE_NAME = "form-row";


    DOMC.addType(TYPE_NAME, {
        model:  MODEL.extend({
            defaults: {
                ...MODEL.prototype.defaults,
                'custom-name': 'Form Row',
                draggable: 'form *',
                droppable: true,
                classes: ['form-row'],
            },
        }),
        view: VIEW.extend({
        })
        
    });

    BM.add(TYPE_NAME, {
        label: "Form Row",
        content: {
            type: TYPE_NAME,
        },
        category: "Forms",
    });
}
